<!-- 新建编码 -->

<!-- 新建员工 -->
 <template>
  <div>
    <!-- 弹出添加修改对话框 -->
    <!-- 新建员工基本信息 -->
    <div class="financeSetA">
      <div class="navCalss">| 创建订单</div>
      <div class="center">
        <el-form
          :model="order"
          :rules="order.form_rules"
          ref="netBarForm"
          label-width="95px"
          style="width: auto"
          label-position="left"
        >
          <!-- 基础信息 -->
          <div class="flex2">
            <div class="font">基本信息</div>
            <div class="btn"></div>
          </div>
          <div class="lineBorder"></div>
          <div class="flex1">
            <div class="flexLeft">
              <el-form-item prop="vipCode" label="客户VIP号 :">
                <el-input
                  v-model="order.vipCode"
                  @focus="showDialog()"
                  placeholder="请输入客户VIP号"
                  style="width: 208px"
                ></el-input>
              </el-form-item>
            </div>
            <div class="flexRight">
              <el-form-item prop="predictTotal" label="商品价值 :">
                <el-input
                  v-model="order.predictTotal"
                  placeholder="整单商品价值,单位元"
                  style="width: 208px"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="flex1">
            <div class="flexLeft">
              <el-form-item prop="expressCompany" label="快递公司 :">
                <el-select
                  v-model="order.expressCompany"
                  placeholder="请输入快递公司"
                  style="width: 208px"
                  filterable
                >
                  <el-option
                    v-for="item in deliveyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            

            <div class="flexRight">
              <el-form-item prop="checkedGoodsType" label="货运类型 :">
                <el-select
                  v-model="order.checkedGoodsType"
                  placeholder="请选择货运类型"
                  style="width: 208px"
                >
                  <el-option
                    v-for="item in goodsType"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="flex1">
            <div class="flexLeft">
              <el-form-item prop="expressNo" label="快递单号:">
                <el-input
                  v-model="order.expressNo"
                  placeholder="请输入快递单号"
                  style="width: 208px"
                ></el-input>
              </el-form-item>
            </div>
            <div class="flexRight">
              <el-form-item prop="remark" label="订单备注:">
                <el-input
                  v-model="order.remark"
                  placeholder="选填"
                  style="width: 208px"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="flex2">
            <div class="font">商品清单</div>
            <div class="btn">
              <el-button type="primary" @click="addProduct()">
                添加商品</el-button
              >
            </div>
          </div>
          <div class="lineBorder"></div>
          <div v-for="(value, index) in order.detailList" :key="index">
            <div class="flex3">
              <div>
                {{ index + 1 }}
              </div>
              <div class="line">
                <el-form-item
                  style="margin-left: -55px"
                  :prop="'detailList.' + index + '.productName'"
                  :rules="[
                    {
                      required: true,
                      message: '商品名称不能为空',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    v-model="value.productName"
                    placeholder="请输入商品名称"
                    style="width: 400px"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="line">
                <el-form-item
                  style="margin-left: -75px"
                  :prop="'detailList.' + index + '.productNum'"
                  :rules="[
                    {
                      required: true,
                      message: '商品数量不能为空',
                      trigger: 'blur',
                    },
                    { type: 'number', message: '商品数量必须为数字值' },
                  ]"
                >
                  <el-input
                    v-model.number="value.productNum"
                    placeholder="商品数量"
                    style="width: 120px"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="line" style="margin-left: 25px">
                <!-- " -->
                <el-button
                  type="text"
                  v-if="order.detailList.length > 1"
                  @click="deleteDialog(index)"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div></div>
    </div>

    <div class="flex4">
      <div>
        <el-button style="width: 150px" type="primary" @click="onSubmit()"
          >提交</el-button
        >
      </div>
    </div>
    <el-dialog
      :visible.sync="adminDeleteDialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="340px"
      center
    >
      <div style="text-align: center">
        <span>您确定移除该商品信息嘛？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="deleteItem(indexA)">删除</el-button>
        <el-button @click="adminDeleteDialog.show = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="adminDeleteDialog.showB"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="1000px"
      center
    >
      <div class="minWidth">
        <el-form
          :inline="true"
          ref="search_data"
          class="demo-form-inline search-form"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="客户名称:">
                <el-input
                  v-model="searchData.keyWordB"
                  placeholder="请输入客户名称"
                  @keyup.enter.native="getCustomer()"
                  style="width: 150px"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="昵称:">
                <el-input
                  v-model="searchData.keyWord"
                  placeholder="请输入昵称"
                  @keyup.enter.native="getCustomer()"
                  style="width: 150px"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手机号:">
                <el-input
                  v-model="searchData.keyWordC"
                  placeholder="请输入手机号"
                  style="width: 150px"
                  @keyup.enter.native="getCustomer()"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                type="primary"
                icon="search"
                @click="getCustomer()"
                style="margin-left: 50px"
                >搜索</el-button
              >
            </el-col>
          </el-row>
          <el-row> </el-row>
        </el-form>
      </div>

      <div class="table_container">
        <el-table :data="customerList" border style="width: 100%" stripe>
          <el-table-column
            prop="adminId"
            label="序号"
            align="center"
            min-width="50px"
          >
            <template slot-scope="scope">
              <span v-text="getIndex(scope.$index)"> </span>
            </template>
          </el-table-column>
          <el-table-column label="用户名" align="center">
            <template slot-scope="scope">
              <div class="wrl-flex" align="center">
                <div class="wrl-name">
                  {{ scope.row.nickname }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="真实姓名" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.realName">{{ scope.row.realName }}</div>
              <div v-else>无</div>
            </template>
          </el-table-column>
          <el-table-column label="联系方式" align="center">
            <template slot-scope="scope">
              <div class="wrl-flex" align="center">
                <div class="wrl-name">
                  {{ scope.row.mobile }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="VIP号" align="center">
            <template slot-scope="scope">
              {{ scope.row.vipCode }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="seleVipCode(scope.row.vipCode)"
                >选择</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="paginationC">
          <el-pagination
            :page-sizes="paginations.page_sizes"
            :page-size="paginations.page_size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page="paginations.page_index"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as confirm from "@/api/confirm";
import * as customer from "@/api/customer";
import * as order from "@/api/order";
export default {
  data() {
    let dataValidate = (rule, value, callback) => {
      if (value === "") {
        let text;
        if (rule.field == "vipCode") {
          text = "名称";
        } else if (rule.field == "expressCompany") {
          text = "快递公司";
        } else if (rule.field == "expressNo") {
          text = "快递号";
        } else if (rule.field == "predictTotal") {
          text = "商品整单价值";
        }else if(rule.field == "checkedGoodsType"){
          text = "货运类型";
        }
        callback(new Error(text + "不能为空"));
      } else {
        if (rule.field == "predictTotal") {
          var reg = /^\d+$|^\d*\.\d+$/g;
          if (!reg.test(value)) {
            callback(new Error("只能输入数字和小数点"));
          }
        }
        return callback();
      }
    };
    return {
      searchData: {
        keyWord: "",
        keyWordB: "",
        keyWordC: "",
      },
      //需要给分页组件传的信息
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      customerList: [], //列表
      deliveyList: [],

      // options: [
      //   {
      //     value: "不合箱",
      //     id: 0,
      //   },
      //   {
      //     value: "合箱",
      //     id: 1,
      //   },
      // ],
      
      goodsType:[
        {
          value: "海运",
          id: 1,
        },
        {
          value: "海运大件",
          id: 2,
        },
        {
          value: "空运",
          id: 3,
        },
      ],
      value: "",
      indexA: "",
      adminDeleteDialog: {
        show: false,
        showB: false,
      },
      //

      //表格信息
      order: {
        width: "400px",
        show: false,
        title: "",
        formLabelWidth: "80px",
        appendOrUpdate: 1, //1/2 添加/更改
        vipCode: "",
        expressCompany: "",
        expressNo: "",
        predictTotal: "",
        checkedGoodsType:"",
        remark: "",
        detailList: [
          {
            detailId: 0,
            productName: "",
            productNum: "",
          },
        ],

        //信息修改规则
        form_rules: {
          predictTotal: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          expressNo: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          vipCode: [
            {
              required: true,
              validator: dataValidate,
              trigger: "change",
            },
          ],
          expressCompany: [
            {
              required: true,
              validator: dataValidate,
              trigger: "change",
            },
          ],
          checkedGoodsType: [
            {
              required: true,
              validator: dataValidate,
              trigger: "change",
            },
          ],
        },
      },
    };
  },
  created() {
    let that = this;
    that.getExpressList();
    that.getCustomer();
  },
  methods: {
    seleVipCode(vipCode) {
      this.order.vipCode = vipCode;
      this.adminDeleteDialog.showB = false;
    },
    showDialog() {
      this.adminDeleteDialog.showB = true;
    },
    getIndex($index) {
      //表格序号
      return (
        (this.paginations.page_index - 1) * this.paginations.page_size +
        $index +
        1
      );
    },
    getCustomer() {
      let that = this;
      let data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        nickname: that.searchData.keyWord ? that.searchData.keyWord : null,
        realName: that.searchData.keyWordB ? that.searchData.keyWordB : null,
        mobile: that.searchData.keyWordC ? that.searchData.keyWordC : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null,
      };
      customer.getCustomerList(data).then((res) => {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.customerList = res.data.data.list;
          that.customerList.forEach(function (val, i) {
            val.addDate = mUtils
              .formatDate(new Date(val.addTime))
              .substring(0, 10);
          });
          that.paginations.total = res.data.data.pageCount;
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    //获取
    getExpressList() {
      let that = this;
      let data = {};
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      confirm.expressList(data).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          that.$message.error("获取快递公司列表失败");
          return;
        }
        that.deliveyList = res.data.data;
      });
    },
    //删除
    deleteDialog(index) {
      this.indexA = index;
      this.adminDeleteDialog.show = true;
    },

    //增加删除地址
    addProduct() {
      this.order.detailList.push({
        detailId: 0,
        productName: "",
        productNum: "",
      });
    },
    deleteItem(index) {
      this.adminDeleteDialog.show = false;
      this.order.detailList.splice(index, 1);
      // this.dialog.detailList.splice(index, 1);
    },
    //返回上一个页面
    back() {
      this.$router.go(-1); //返回上一层
    },
    //提交表单
    onSubmit() {
      let that = this;
      let data = {};
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);

      let validd;
      that.$refs.netBarForm.validate((valid) => {
        validd = valid;
        return true;
      });

      if (validd) {
        data = {
          operatorId: mUtils.getStore("userinfo").adminId,
          orderNo: that.order.orderNo,
          vipCode: that.order.vipCode,
          expressCompany: that.order.expressCompany,
          expressNo: that.order.expressNo,
          predictTotal: that.order.predictTotal,
          goodType:that.order.checkedGoodsType,
          remark: that.order.remark,
          detailList: that.order.detailList,
        };

        order.createOrder(data).then(function (res) {
          if (res.data.code != 0) {
            if(res.data.code == 1405){
              let msg = res.data.msg;
              that.$message({
                message: msg,
                type: "warning",
              });
              loading.close();
            }
          } else {
            let msg = "添加成功";
            that.$message({
              message: msg,
              type: "success",
            });
            that.$router.push({
              path: "orderList",
            });
            loading.close();
          }
        });
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;

      that.getCustomer();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;

      that.getCustomer();
    },
    // 清除表单
    closeDialog(form) {
      if (this.$refs[form] !== undefined) {
        this.$refs[form].resetFields();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.financeSetA {
  margin: 20px 50px;
}
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
}
.center {
  margin: 20px 0;
  display: flex;
  justify-content: center;
}
.flex1 {
  display: flex;

  //   justify-content: space-between;
  .flexLeft {
    flex: 12;
  }
  .flexRight {
    flex: 6;
    margin-left: 5vw;
  }
}
.flex2 {
  display: flex;
  justify-content: space-between;
  line-height: 30px;
  height: 30px;
  align-items: center;
  .font {
    font-family: "PingFangSC-Medium", "PingFang SC Medium", "PingFang SC",
      sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    color: #555555;
    line-height: normal;
    font-weight: bold;
  }
}
.lineBorder {
  margin: 15px 0;
  height: 1px;
  background: #D7D7D7;
}
.flex3 {
  display: flex;
  line-height: 60px;
  height: 60px;
  align-items: center;
  .line {
    line-height: 40px;
    height: 40px;
  }
}
.flex4 {
  display: flex;
  margin-top: 50px;
  justify-content: center;
}
.paginationC {
  text-align: center;
  margin-top: 30px;
}
</style>
<style >
.btn .el-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  /* background: #FFF;
    border: 1px solid #DCDFE6; */
  /* color: #606266; */
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  padding: 7px 20px;
  font-size: 14px;
  border-radius: 4px;
}
/* .line  el-form-item{
              margin-left: -95px ;
          } */
</style>


// WEBPACK FOOTER //
// addOrder.vue?3f73b1ad